import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
    MAX_PAGE_SIZE,
    REVIEW_MODAL_TYPE,
    setReviewModalOpen,
    setReviewModalPageNum,
    setReviewModalType,
    setActivePageNum,
    selectSelectedSubmissionView,
    selectSelectedRegistrationView,
    selectSidebarStep,
    selectIsMultiSelectMode,
} from 'state/review'
import { STATE_KEYS } from 'state/requests'
import { createGetRequestPagination, selectRequestsAreLoading } from 'state'
import { selectBatchCount, SUBMISSION_VIEW_ENUM } from 'state/submissions'
import { isShowCardReviewComponent } from 'components/utils'
import Pagination from 'particles/Pagination'
import { isNoneSubmitBlockExisted } from 'components/utils/submission'

const SubmissionPagination: React.FC = () => {
    const dispatch = useDispatch()
    const selectedSubmissionView = useSelector(selectSelectedSubmissionView)
    const selectedRegistrationView = useSelector(selectSelectedRegistrationView)
    const batchCount = useSelector(selectBatchCount)
    const isMultiSelectMode = useSelector(selectIsMultiSelectMode)
    const selectedStateKey = STATE_KEYS.SubmissionsList
    const pagination = useSelector(createGetRequestPagination(selectedStateKey))
    const sidebarStep = useSelector(selectSidebarStep)
    const viewRef = useRef<string | null>(null)
    const [itemCount, setItemCount] = useState(0)
    const isLoading = useSelector(selectRequestsAreLoading([STATE_KEYS.SubmissionsList]))

    useEffect(() => {
        const count =
            selectedSubmissionView === SUBMISSION_VIEW_ENUM.BATCH_SUBMISSIONS
                ? batchCount
                : pagination.count
                  ? pagination.count
                  : 0
        if (selectedSubmissionView !== viewRef.current) {
            setItemCount(0)
        } else if (!isLoading) {
            setItemCount(count)
        }
        viewRef.current = selectedSubmissionView
    }, [selectedSubmissionView, batchCount, pagination.count, isLoading])

    const setLeaveModalType = (): void => {
        dispatch(setReviewModalType(REVIEW_MODAL_TYPE.LEAVE))
    }

    const setModalPageNum = (pageNum: number): void => {
        dispatch(setReviewModalPageNum(pageNum))
    }

    const setModalOpen = (isOpen: boolean): void => {
        dispatch(setReviewModalOpen(isOpen))
    }

    const setPageNum = (pageNum: number): void => {
        dispatch(setActivePageNum(pageNum))
    }

    const handlePageClick = (page: number) => {
        if (isMultiSelectMode) {
            setLeaveModalType()
            setModalPageNum(page)
            setModalOpen(true)
        } else {
            setPageNum(page)
        }
    }
    const isHidePaginationInCardView = () => {
        if (selectedSubmissionView === SUBMISSION_VIEW_ENUM.BATCH_SUBMISSIONS) {
            return false
        }

        if (!sidebarStep) {
            return false
        }

        return !isShowCardReviewComponent(sidebarStep.type) || isNoneSubmitBlockExisted(sidebarStep)
    }

    if (
        selectedSubmissionView === SUBMISSION_VIEW_ENUM.REJECTED ||
        selectedSubmissionView === SUBMISSION_VIEW_ENUM.DROPOUTS ||
        selectedRegistrationView !== null ||
        isHidePaginationInCardView()
    )
        return null
    return (
        <Pagination
            itemPerPage={MAX_PAGE_SIZE}
            totalItems={itemCount}
            onPageChange={page => handlePageClick(page - 1)}
        />
    )
}

export default SubmissionPagination
